import { render, staticRenderFns } from "./StudyDialog.vue?vue&type=template&id=5dfaa0d6&scoped=true&"
import script from "./StudyDialog.vue?vue&type=script&lang=js&"
export * from "./StudyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfaa0d6",
  null
  
)

export default component.exports